export default __webpack_public_path__ + "dist/assets/rallies-bg.png";